const Divider = () => <div className="h-px bg-gray-200" />

export default Divider
